import { type FC, useEffect } from 'react';

import { find } from 'lodash-es';

import { selectMetadataMultiSelectFieldNames } from '../../components/search_items/selectors';
import { refreshAppState } from '../../ducks/app/slice';
import { historyPush } from '../../ducks/history/actions';
import { getMetadataView } from '../../ducks/metadata_view/thunks';
import { criteriaToFacetValues } from '../../ducks/pages/search/utils';
import { searchFilterActions } from '../../ducks/panels/search_filters/actions';
import { fetchSearchHistory } from '../../ducks/panels/search_history/thunks';
import { useAppDispatch, useAppSelector } from '../../store/react_redux_typed';
import { selectUserRoles } from '../../utils/get_user_roles';
import { criteriaToFilterValues } from '../../utils/search_utils/criteria_to_filter_values';
import SearchHistoryPanelComponent from './component';
import { selectSearchHistory } from './selectors';

const SearchHistoryPanel: FC = () => {
  const dispatch = useAppDispatch();
  const searchHistory = useAppSelector(selectSearchHistory);
  const dateTimeFormat = useAppSelector(
    (state) => state.appReducer.dateTimeFormat,
  );
  const roles = useAppSelector(selectUserRoles);
  const metadataMultiSelectFieldNames = useAppSelector(
    selectMetadataMultiSelectFieldNames,
  );

  useEffect(() => {
    if (roles.canReadSearchHistory) {
      dispatch(fetchSearchHistory());
    }
  }, [roles.canReadSearchHistory]);

  return (
    <SearchHistoryPanelComponent
      searchHistory={searchHistory}
      onSelect={(criteria) => {
        if (criteria.metadata_view_id) {
          dispatch(getMetadataView(criteria.metadata_view_id));
        }
        if (!criteria.filter) {
          return;
        }
        const collection = find(criteria.filter.terms, {
          name: 'in_collections',
        });
        dispatch(searchFilterActions.setQuery(criteria.query ?? ''));
        const { filterValues } = criteriaToFilterValues(
          criteria,
          undefined,
          metadataMultiSelectFieldNames,
        );
        dispatch(searchFilterActions.setFilterValues(filterValues));
        dispatch(
          searchFilterActions.setFacetValues(
            criteriaToFacetValues(criteria?.facets_filters ?? []),
          ),
        );
        if (collection) {
          dispatch(
            historyPush(
              `/collection/${collection.value ?? collection.value_in?.[0]}`,
            ),
          );
        } else {
          dispatch(historyPush('/search'));
        }
        dispatch(refreshAppState());
      }}
      dateFormat={dateTimeFormat}
    />
  );
};

export default SearchHistoryPanel;
